import React from "react";
import { TableCell, TableRow, Chip } from "@mui/material";
import styled from "styled-components";

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 20px;
  height: 35px;
`;

const AMreadonlyrow = ({
  k, row, onClickEdit, handleDeleteClick,
  SubmitButton, page, rowsPerPage, user,
  nameStringFn, tableFontSize = 14,
}) => {
  // Use responsive font size
  const responsiveFontSize = tableFontSize;
  
  return (
    <TableRow key={k} name={row?.categ}>
      <TableCell component="th" scope="row" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {page * rowsPerPage + k + 1}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.storeoffice}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.ApplAssetCateg?.map((item) => (
          <Chip key={item} label={item} sx={{ marginRight: 0.5, fontSize: '11px', height: '20px' }} />
        ))}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.ApplConsumCateg?.map((item) => (
          <Chip key={item} label={item} sx={{ marginRight: 0.5, fontSize: '11px', height: '20px' }} />
        ))}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.ItemAdder_A?.length && user?.[row?.roleUsers?.ItemAdder_A]
          ? nameStringFn(user[row?.roleUsers?.ItemAdder_A])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1Approver_A?.length && user?.[row?.roleUsers?.L1Approver_A]
          ? nameStringFn(user[row?.roleUsers?.L1Approver_A])
          : "Vacant"}
      </TableCell>
      
      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2Approver_A?.length && user?.[row?.roleUsers?.L2Approver_A]
          ? nameStringFn(user[row?.roleUsers?.L2Approver_A])
          : "Vacant"}
      </TableCell>
      
      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1ReqApprover_A?.length && user?.[row?.roleUsers?.L1ReqApprover_A]
          ? nameStringFn(user[row?.roleUsers?.L1ReqApprover_A])
          : "Vacant"}
      </TableCell>
      
      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2ReqApprover_A?.length && user?.[row?.roleUsers?.L2ReqApprover_A]
          ? nameStringFn(user[row?.roleUsers?.L2ReqApprover_A])
          : "Vacant"}
      </TableCell>
      
      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.ItemAdder_C?.length && user?.[row?.roleUsers?.ItemAdder_C]
          ? nameStringFn(user[row?.roleUsers?.ItemAdder_C])
          : "Vacant"}
      </TableCell>
      
      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1Approver_C?.length && user?.[row?.roleUsers?.L1Approver_C]
          ? nameStringFn(user[row?.roleUsers?.L1Approver_C])
          : "Vacant"}
      </TableCell>
      
      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2Approver_C?.length && user?.[row?.roleUsers?.L2Approver_C]
          ? nameStringFn(user[row?.roleUsers?.L2Approver_C])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1ReqApprover_C?.length && user?.[row?.roleUsers?.L1ReqApprover_C]
          ? nameStringFn(user[row?.roleUsers?.L1ReqApprover_C])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2ReqApprover_C?.length && user?.[row?.roleUsers?.L2ReqApprover_C]
          ? nameStringFn(user[row?.roleUsers?.L2ReqApprover_C])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L1Support?.length && user?.[row?.roleUsers?.L1Support]
          ? nameStringFn(user[row?.roleUsers?.L1Support])
          : "Vacant"}
      </TableCell>
      
      <TableCell align="left" sx={{ fontSize: responsiveFontSize, padding: '8px' }}>
        {row?.roleUsers?.L2Support?.length && user?.[row?.roleUsers?.L2Support]
          ? nameStringFn(user[row?.roleUsers?.L2Support])
          : "Vacant"}
      </TableCell>

      <TableCell align="left" sx={{ padding: '8px' }}>
        <ButtonWrapper>
          <SubmitButton
            type="button"
            sx={{ backgroundColor: "#ed6c02", color: "lightgreen", height: 30, marginRight: 1, fontSize: '12px' }}
            onClick={(e) => onClickEdit(e, k, row)}
          >
            Edit
          </SubmitButton>

          <SubmitButton
            type="button"
            sx={{ backgroundColor: "#D32F2F", color: "lightgreen", height: 30, fontSize: '12px' }}
            onClick={(e) => handleDeleteClick(e, k, row)}
          >
            Delete
          </SubmitButton>
        </ButtonWrapper>
      </TableCell>
    </TableRow>
  );
};

export default AMreadonlyrow;
